import { createContext } from 'react';

export const context = createContext<string | null>(null);
